
    import infoList from './infoList.vue'
    import componentTitle from './componentTitle.vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        listSumNumber: number;
        reportLevel: number;
    }

    export default defineComponent({
        name: "configurationInfo",
        setup() {
            let state: State = reactive({
                dataList: [],
                listSumNumber: 0,
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {configureInfos} = data;
                state.dataList = configureInfos;
                state.listSumNumber = configureInfos.length;
            })
            return {
                state
            }
        },
        components: {
            infoList,
            componentTitle
        }
    })
